module.exports = __webpack_public_path__ + "static/media/memberGroupDeletedIcon.c222ebc0.png";